var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container-wrapper"},[_c('div',{attrs:{"id":"amap-container"}}),_c('MapLegend')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }